import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import NewTendersNotification from "./Notifications/NewTendersNotification";
import TenderWonNotification from "./Notifications/TenderWonNotification";
import './NotificationList.css';

class NotificationList extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        notifications: [
            {
                notificationId: 1,
                type: 'TenderWon',
                tenderId: 1,
                tenderNumber: '0012',
                tenderSum: 220,
                tenderWonSeq: 12,
                deliveryDate: (new Date()).toString(),
                timestamp: (new Date()).toString()
            },
            {
                notificationId: 2,
                type: 'NewTenders',
                tenderCount: 9,
                timestamp: (new Date()).toString()
            }
        ],
        count: 2
    };

    render() {
        const {notifications, count} = this.state;
        return (
            <li className="dropdown">
                <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button">
                    <i className="px-navbar-icon fa fa-bullhorn font-size-14"/>
                    <span className="px-navbar-icon-label">Уведомления</span>
                    <span className="px-navbar-label label label-success">{count}</span>
                </a>
                <div className="dropdown-menu p-a-0" style={{width: '300px'}}>
                    <div id="navbar-notifications" style={{height: '280px', position: 'relative'}}>
                        {notifications.map(n => {
                            switch (n.type) {
                                case 'NewTenders':
                                    return <NewTendersNotification key={n.notificationId} data={n}/>;
                                case 'TenderWon':
                                    return <TenderWonNotification key={n.notificationId} data={n}/>;
                                default:
                                    return null;
                            }
                        })}
                    </div>
                    <Link to="/" className="widget-more-link">ПОСМОТРЕТЬ ВСЕ СОБЫТИЯ...</Link>
                </div>
            </li>
        );
    }
}

export default NotificationList;


// WEBPACK FOOTER //
// ./src/components/NotificationList.js